<template>
    <VContent>
        <VContainer>
            <VLayout wrap v-if="reg">
                <VFlex xs12 sm8 offset-sm1 v-for="(r,i) in reg" :key="i">
                    <!--<DoublesCard v-for="(t,i) in reg.teams" :p1="t[0]" :p2="t[1]" :key="t[0].unqid" />-->
                    <VCard v-for="(t,i) in r.teams" class="mt-1">
                        <VCardText class="font-weight-light title">
                            {{t[0]['profile.firstname']}} {{t[0]['profile.lastname']}}
                            <v-divider></v-divider>
                            {{t[1]['profile.firstname']}} {{t[1]['profile.lastname']}}
                        </VCardText>
                    </VCard>
                </VFlex>
            </VLayout>
        </VContainer>
    </VContent>
</template>

<script>
  import {
    mapActions
  } from 'vuex'
  import DoublesCard from "@/components/registration/DoublesCard";
  export default {
    components: {DoublesCard},
    name: "Teams",
    data() {
      return {
        eventid:155
      }
    },
    computed:{
      reg(){
        return this.$store.state.registration
      }
    },
    mounted() {

    },
    methods: {
      ...mapActions(['getCustomer','openGet'])
    }
  }
</script>

<style scoped>

</style>